import React from 'react';
import Loadable from 'react-loadable';

import LoadableLoading from 'components/LoadableLoading';
import { IProps } from './interface';

export const path = '/chrona/access';

// На уровне модуля, а не в компоненте: управление и участок в адресе иначе пересоздавали бы страницу целиком.
const LoadableMap = Loadable.Map({
  loader: {
    page: () => import('./page'),
    i18n: () => import('./ru.json'),
  },
  loading: LoadableLoading,
  render(loaded: any, loadedProps: {}) {
    const Page = loaded.page.default;

    return <Page i18n={loaded.i18n} {...loadedProps} />;
  },
});

const PageChronaAccess: React.FC<IProps> = (props) => <LoadableMap {...props} />;

export default PageChronaAccess;
